import React from 'react';
import BookCard from './BookCard';
import Icon from '../../../components/AppIcon';

const BookGrid = ({ books, viewMode, loading, onAddToFavorites, onAddToCart }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="text-center">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4 mx-auto animate-pulse">
            <Icon name="BookOpen" size={24} className="text-primary" />
          </div>
          <p className="font-body text-scholarly-gray">Cargando biblioteca...</p>
        </div>
      </div>
    );
  }

  if (books?.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-6 mx-auto">
          <Icon name="Search" size={32} className="text-scholarly-gray" />
        </div>
        <h3 className="font-headline text-xl font-semibold text-foreground mb-2">
          No se encontraron libros
        </h3>
        <p className="font-body text-scholarly-gray mb-6 max-w-md mx-auto">
          Intenta ajustar los filtros de búsqueda o explora nuestras colecciones recomendadas.
        </p>
      </div>
    );
  }

  const getGridClasses = () => {
    switch (viewMode) {
      case 'list':
        return 'grid grid-cols-1 gap-6';
      case 'compact':
        return 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4';
      default: // grid
        return "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4"
    }
  };

  return (
    <div className={getGridClasses()}>
      {books?.map((book) => (
        <BookCard
          key={book?.id}
          book={book}
          viewMode={viewMode}
          onAddToFavorites={onAddToFavorites}
          onAddToCart={onAddToCart}
        />
      ))}
    </div>
  );
};

export default BookGrid;